exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".m-policy-layer .m-pop-wrapper[data-v-727ca4b4]{right:34px;bottom:37px;width:228px}.m-policy-layer .m-body[data-v-727ca4b4]{padding:40px 30px 30px}.m-policy-layer .bottom[data-v-727ca4b4]{display:flex;justify-content:space-between;align-items:center;margin-top:52px}.m-policy-layer .m-btn[data-v-727ca4b4]{width:auto}", ""]);

